module.exports = __webpack_public_path__ + "assets/ff5cc5e8b8666b359b9c10d8b4abfb59.mp4";